import React from 'react';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { DragIndicator } from '@material-ui/icons';

import { DraggableHOC } from '../DraggableHOC/DraggableHOC';
import { WebsiteSection as IHomepageSection } from '../../types/sections';
import { StyledHomepageSectionContainer, StyledName, StyledSwitch } from './HomepageSection.styled';

type Props = {
  provided?: DraggableProvided;
  snapshot?: DraggableStateSnapshot;
  item: IHomepageSection;
  enabled: boolean;
  disabled?: boolean;
  onSwitch: (active: boolean) => void;
};

const HomepageSection = ({ provided, snapshot, item, enabled, disabled, onSwitch }: Props) => {
  const isDraggable = !item.static && enabled;

  const child = (
    <StyledHomepageSectionContainer
      ref={provided?.innerRef}
      {...(isDraggable && {
        ...provided?.dragHandleProps,
        ...provided?.draggableProps,
      })}
    >
      {isDraggable && <DragIndicator />}
      <StyledName>{item.title}</StyledName>
      <StyledSwitch disabled={disabled} onChange={(_: any, active: boolean) => onSwitch(active)} checked={enabled} />
    </StyledHomepageSectionContainer>
  );

  if (isDraggable && provided && snapshot) {
    return (
      <DraggableHOC provided={provided} snapshot={snapshot}>
        {child}
      </DraggableHOC>
    );
  }

  return child;
};

export default HomepageSection;
